export const EMBEDDED_BROWSER_USER_AGENT_MARKERS = [
  'fban',
  'fbav',
  'fb_iab',
  'instagram',
  'messenger',
  'whatsapp',
  'telegram',
  'line',
  'micromessenger',
  'snapchat',
  'viber',
  'skype',
  'teams',
  'outlook',
  'gmail',
  'gsa/',
  '; wv',
  ' wv)',
  'webview',
] as const;
